(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["about-lois-london"] && !Shopify.designMode) return;
  try {
    
(function () {
  var root = document.querySelector('.ll-about');
  if (!root) return;

  var items = root.querySelectorAll('.ll-text, .ll-split, .ll-full, .ll-quote, .ll-cta');

  if (!('IntersectionObserver' in window)) {
    items.forEach(function (el) { el.classList.add('is-visible'); });
    return;
  }

  var io = new IntersectionObserver(function (entries) {
    entries.forEach(function (entry) {
      if (entry.isIntersecting) {
        entry.target.classList.add('is-visible');
        io.unobserve(entry.target);
      }
    });
  }, { threshold: 0.12, rootMargin: '0px 0px -40px 0px' });

  items.forEach(function (el) { io.observe(el); });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["contact-page"] && !Shopify.designMode) return;
  try {
    
(function () {
  var root = document.querySelector('#ll-contact-{{ section.id }}');
  if (!root) return;

  var form = root.querySelector('[data-contact-form]');
  if (!form) return;

  /* ─── SPAM PROTECTION ─── */
  var MIN_FILL_TIME_MS = 3000; /* Submissions faster than this are bot-like */
  var loadedAt = Date.now();
  var timeField = form.querySelector('[data-form-time]');
  if (timeField) timeField.value = loadedAt;

  form.addEventListener('submit', function (e) {
    /* 1. Honeypot check */
    var hp1 = form.querySelector('input[name="contact[website]"]');
    var hp2 = form.querySelector('input[name="contact[company_hp]"]');
    if ((hp1 && hp1.value !== '') || (hp2 && hp2.value !== '')) {
      e.preventDefault();
      console.warn('Submission blocked: honeypot triggered');
      /* Silently fake success — don't tell the bot it failed */
      showFakeSuccess();
      return false;
    }

    /* 2. Time check */
    var elapsed = Date.now() - loadedAt;
    if (elapsed < MIN_FILL_TIME_MS) {
      e.preventDefault();
      console.warn('Submission blocked: too fast (' + elapsed + 'ms)');
      showFakeSuccess();
      return false;
    }

    /* All good — let the form submit normally */
    var btn = form.querySelector('.ll-contact__btn');
    if (btn) {
      btn.disabled = true;
      btn.textContent = 'Sending...';
    }
  });

  function showFakeSuccess() {
    /* Reset button so user can resubmit if they were real */
    var btn = form.querySelector('.ll-contact__btn');
    if (btn) {
      btn.disabled = false;
      btn.textContent = btn.getAttribute('data-original-text') || 'Send Message';
    }
  }
  /* ─── /SPAM PROTECTION ─── */

  var success = root.querySelector('.ll-contact__success');
  if (success) { setTimeout(function () { success.scrollIntoView({ behavior: 'smooth', block: 'center' }); }, 100); }
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["custom-bridal"] && !Shopify.designMode) return;
  try {
    
(function () {
  var root = document.querySelector('.ll-bridal');
  if (!root) return;

  // Reveal on scroll
  if ('IntersectionObserver' in window) {
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          root.classList.add('is-visible');
          io.unobserve(entry.target);
        }
      });
    }, { threshold: 0.15 });
    io.observe(root);
  } else {
    root.classList.add('is-visible');
  }

  // Loading state on submit
  var form = root.querySelector('[data-bridal-form]');
  if (!form) return;

  /* ─── SPAM PROTECTION ─── */
  var MIN_FILL_TIME_MS = 3000; /* Submissions faster than this are bot-like */
  var loadedAt = Date.now();
  var timeField = form.querySelector('[data-form-time]');
  if (timeField) timeField.value = loadedAt;

  form.addEventListener('submit', function (e) {
    /* 1. Honeypot check */
    var hp1 = form.querySelector('input[name="contact[website]"]');
    var hp2 = form.querySelector('input[name="contact[company_hp]"]');
    if ((hp1 && hp1.value !== '') || (hp2 && hp2.value !== '')) {
      e.preventDefault();
      console.warn('Submission blocked: honeypot triggered');
      showFakeSuccess();
      return false;
    }

    /* 2. Time check */
    var elapsed = Date.now() - loadedAt;
    if (elapsed < MIN_FILL_TIME_MS) {
      e.preventDefault();
      console.warn('Submission blocked: too fast (' + elapsed + 'ms)');
      showFakeSuccess();
      return false;
    }

    /* All good — let the form submit normally */
    var btn = form.querySelector('.ll-bridal__btn');
    if (!btn) return;
    btn.disabled = true;
    btn.dataset.original = btn.textContent;
    btn.textContent = 'Sending...';
  });

  function showFakeSuccess() {
    /* Silently fake success — bot doesn't learn that protection exists */
    var btn = form.querySelector('.ll-bridal__btn');
    if (btn) {
      btn.disabled = false;
      btn.textContent = btn.dataset.original || btn.textContent;
    }
  }
  /* ─── /SPAM PROTECTION ─── */

  // Auto-scroll to success message
  var success = root.querySelector('.ll-bridal__success');
  if (success) {
    setTimeout(function () {
      success.scrollIntoView({ behavior: 'smooth', block: 'center' });
    }, 100);
  }
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["gallery-page"] && !Shopify.designMode) return;
  try {
    
(function () {
  var root = document.querySelector('.ll-gallery');
  if (!root) return;

  var items = Array.prototype.slice.call(root.querySelectorAll('[data-gallery-item]'));
  if (items.length === 0) return;

  var lightbox = root.querySelector('[data-gallery-lightbox]');
  var imgEl = root.querySelector('[data-gallery-img]');
  var loader = root.querySelector('[data-gallery-loader]');
  var counter = root.querySelector('[data-gallery-counter]');
  var captionEl = root.querySelector('[data-gallery-caption]');
  var btnClose = root.querySelector('[data-gallery-close]');
  var btnPrev = root.querySelector('[data-gallery-prev]');
  var btnNext = root.querySelector('[data-gallery-next]');
  var stage = root.querySelector('[data-gallery-stage]');

  var currentIndex = 0;
  var total = items.length;

  function buildSlide(index) {
    var item = items[index];
    if (!item) return;

    var fullSrc = item.dataset.full || item.href;
    var caption = item.dataset.caption || '';

    loader.classList.add('is-active');
    imgEl.classList.remove('is-loaded');

    var preload = new Image();
    preload.onload = function () {
      imgEl.src = fullSrc;
      imgEl.alt = caption || 'Gallery image ' + (index + 1);
      imgEl.classList.add('is-loaded');
      loader.classList.remove('is-active');
    };
    preload.onerror = function () { loader.classList.remove('is-active'); };
    preload.src = fullSrc;

    counter.textContent = (index + 1) + ' / ' + total;
    captionEl.textContent = caption;
  }

  function openLightbox(index) {
    currentIndex = index;
    lightbox.classList.add('is-open');
    lightbox.setAttribute('aria-hidden', 'false');
    document.body.classList.add('ll-gallery-open');
    buildSlide(currentIndex);
    btnClose.focus();
  }

  function closeLightbox() {
    lightbox.classList.remove('is-open');
    lightbox.setAttribute('aria-hidden', 'true');
    document.body.classList.remove('ll-gallery-open');
    setTimeout(function () {
      if (!lightbox.classList.contains('is-open')) {
        imgEl.src = '';
        imgEl.classList.remove('is-loaded');
      }
    }, 350);
  }

  function showPrev() {
    currentIndex = (currentIndex - 1 + total) % total;
    buildSlide(currentIndex);
    preloadNeighbors(currentIndex);
  }
  function showNext() {
    currentIndex = (currentIndex + 1) % total;
    buildSlide(currentIndex);
    preloadNeighbors(currentIndex);
  }

  items.forEach(function (item, idx) {
    item.addEventListener('click', function (e) {
      e.preventDefault();
      openLightbox(idx);
    });
  });

  btnClose.addEventListener('click', closeLightbox);
  btnPrev.addEventListener('click', showPrev);
  btnNext.addEventListener('click', showNext);

  lightbox.addEventListener('click', function (e) {
    if (e.target === lightbox || e.target === stage) closeLightbox();
  });

  document.addEventListener('keydown', function (e) {
    if (!lightbox.classList.contains('is-open')) return;
    if (e.key === 'Escape') closeLightbox();
    else if (e.key === 'ArrowLeft') showPrev();
    else if (e.key === 'ArrowRight') showNext();
  });

  var touchStartX = 0, touchEndX = 0, touchThreshold = 50;
  stage.addEventListener('touchstart', function (e) { touchStartX = e.changedTouches[0].screenX; }, { passive: true });
  stage.addEventListener('touchend', function (e) {
    touchEndX = e.changedTouches[0].screenX;
    var diff = touchEndX - touchStartX;
    if (Math.abs(diff) < touchThreshold) return;
    if (diff > 0) showPrev();
    else showNext();
  }, { passive: true });

  function preloadNeighbors(index) {
    [index - 1, index + 1].forEach(function (i) {
      var targetIdx = (i + total) % total;
      var targetItem = items[targetIdx];
      if (targetItem) {
        var preload = new Image();
        preload.src = targetItem.dataset.full || targetItem.href;
      }
    });
  }
})();

  } catch(e) { console.error(e); }
})();
})();
